import(/* webpackMode: "eager" */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "C:\\Users\\DELL\\Desktop\\Ubaid Work\\nubitsoft_V2\\src\\GlobalRedux\\Provider.js");
